/*
 *
 * Home constants
 *
 */

export const CONSOLE_LOG = 'app/App/CONSOLE_LOG';

export const UNAUTHORIZED = 'app/App/UNAUTHORIZED';
export const SET_UNAUTHORIZED = 'app/App/SET_UNAUTHORIZED';
export const SET_REINTALIZE = 'app/App/SET_REINTALIZE';

export const USER_DATA = 'app/App/USER_DATA';
export const USER_DATA_ADD = 'app/App/USER_DATA_ADD';
export const USER_TOKEN = 'app/App/USER_TOKEN';
export const USER_FETCHED = 'app/App/USER_FETCHED';

export const SET_HAS_ALL_ORGANIZATIONS = 'app/App/SET_HAS_ALL_ORGANIZATIONS';

export const ORGANIZATIONS_DATA = 'app/App/ORGANIZATIONS_DATA';
export const ORGANIZATIONS_DATA_ADD = 'app/App/ORGANIZATIONS_DATA_ADD';
export const ORGANIZATIONS_FETCHED = 'app/App/ORGANIZATIONS_FETCHED';
export const CURRENT_ORAGNIZATION_DATA = 'app/App/CURRENT_ORAGNIZATION_DATA';

export const SET_SMALL_MAIN_NAV = 'app/App/SET_SMALL_MAIN_NAV';


export const SET_IS_LOADED = 'app/App/SET_IS_LOADED';
